import {Loading} from "element-ui";

const promiseAllSequentially = (arr, promiseMapper) => {
    const errors = []
    const promiseAll = arr.reduce((chain, ele) => {
        return new Promise(resolve => {
            chain.then(() => {
                const curPromise = promiseMapper(ele)
                curPromise.then(resolve).catch(err => {
                    errors.push(err)
                    resolve()
                })
            })
        })
    }, Promise.resolve())

    return new Promise(((resolve, reject) => {
        promiseAll.then(() => {
            console.log('promiseAll Done...')
            if (errors.length) {
                reject(errors[0])
            } else {
                resolve()
            }
        })
    }))
}

function computedIdList(repStr) {
    while (repStr.indexOf('，') > -1) {
        repStr = repStr.replace('，', ',')
    }
    while (repStr.indexOf('\n') > -1) {
        repStr = repStr.replace('\n', ',')
    }
    const strs = repStr.split(',')
    const idList = []
    strs.forEach(str => {
        const s = str.trim()
        if (s !== '') {
            idList.push(s)
        }
    })
    return idList
}

function unique(array, field = null) {
    if (field === null) {
        return Array.from(new Set(array));
    } else {
        const res = new Map();
        return array.filter((item) => !res.has(item[field]) && res.set(item[field], 1));
    }
}

function distinct(array, mapper) {
    return [...new Set(array.map(mapper))]
}

function getGlobalLoading(options) {
    const defaultOptions = {
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    }
    options = options || {}
    const finalOptions = {...defaultOptions, ...options}
    return Loading.service(finalOptions)
}


export default {
    promiseAllSequentially,
    computedIdList,
    unique,
    distinct,
    getGlobalLoading
}


// WEBPACK FOOTER //
// ./src/utils/index.js